import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'

const BUFFET_MENU_PDF = '/assets/docs/TSR_Intimate_Celebrations_30_Guests_FINAL.pdf';

function isMobilePdfContext() {
	return window.matchMedia('(max-width: 767px)').matches
		|| window.matchMedia('(pointer: coarse)').matches;
}

function openBuffetMenuPdf(event) {
	if (!isMobilePdfContext()) return;

	event.preventDefault();

	// Mobile browsers often ignore target="_blank" for PDFs; same-tab open is more reliable.
	window.location.assign(BUFFET_MENU_PDF);
}

function Menu() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div data-elementor-type="wp-page" data-elementor-id="1872" className="elementor elementor-1872">
									<div className="elementor-element elementor-element-733beb2 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="733beb2" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
										<div className="elementor-element elementor-element-9ff435e e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="9ff435e" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-ef749cc elementor-invisible elementor-widget elementor-widget-elementskit-heading" data-id="ef749cc" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Menu</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div></div></div>				</div>
												</div>
											</div>
										</div>
									</div>
									<div className="elementor-element elementor-element-0cb1dcc e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="0cb1dcc" data-element_type="container" data-e-type="container">
										<div className="elementor-element elementor-element-3cbc1cc e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="3cbc1cc" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-68f91b3 ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="68f91b3" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con">        {/* link opening */}
														{/* end link opening */}

														<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
															<div className="elementskit-box-header">
																<div className="elementskit-info-box-icon ">
																	<img loading="lazy" decoding="async" src="/assets/images/01/buffet-catering.webp" className="attachment-large size-large" alt="Buffet Catering with Services" />                </div>
															</div>
															<div className="box-body">
																<h3 className="elementskit-info-box-title">
																	Buffet Catering with Services
																</h3>
																<div className="box-footer disable_hover_button">
																	<div className="btn-wraper">
																		<a
																			href={BUFFET_MENU_PDF}
																			target="_blank"
																			rel="noopener noreferrer"
																			onClick={openBuffetMenuPdf}
																		>
																			EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																	</div>
																</div>
															</div>


														</div>
													</div>				</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-a0e0c9e e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="a0e0c9e" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-053f646 ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="053f646" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con">        {/* link opening */}
														{/* end link opening */}

														<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
															<div className="elementskit-box-header">
																<div className="elementskit-info-box-icon ">
																	<img decoding="async" width="1920" height="1080" src="/assets/images/01/cooked-dish.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/cooked-dish.jpg 1920w, /assets/images/01/cooked-dish-300x169.jpg 300w, /assets/images/01/cooked-dish-1024x576.jpg 1024w, /assets/images/01/cooked-dish-768x432.jpg 768w, /assets/images/01/cooked-dish-1536x864.jpg 1536w" sizes="(max-width: 1920px) 100vw, 1920px" />                </div>
															</div>
															<div className="box-body">
																<h3 className="elementskit-info-box-title">
																	For 4 to 50 Guests (Delivery Services)
																</h3>
																<div className="box-footer disable_hover_button">
																	<div className="btn-wraper">
																		<a href="https://partymealsbykilo.petpooja.site/" target="_blank" rel="noopener noreferrer">
																			EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																	</div>
																</div>
															</div>


														</div>
													</div>				</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-9f6c1e7 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="9f6c1e7" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-506f907 ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="506f907" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con">        {/* link opening */}
														{/* end link opening */}

														<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
															<div className="elementskit-box-header">
																<div className="elementskit-info-box-icon ">
																	<img loading="lazy" decoding="async" src="/assets/images/01/mini-buffet.webp" className="attachment-large size-large" alt="Mini Buffet (Coming Soon)" />                </div>
															</div>
															<div className="box-body">
																<h3 className="elementskit-info-box-title">
																	Mini Buffet (Coming Soon)
																</h3>
																<div className="box-footer disable_hover_button">
																	<div className="btn-wraper">
																		<a>
																			EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																	</div>
																</div>
															</div>


														</div>
													</div>				</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-d65483c e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="d65483c" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-99982ad ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="99982ad" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con">        {/* link opening */}
														{/* end link opening */}

														<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
															<div className="elementskit-box-header">
																<div className="elementskit-info-box-icon ">
																	<img loading="lazy" decoding="async" src="/assets/images/01/events-decoration.png" className="attachment-large size-large" alt="Events &amp; Decoration" />                </div>
															</div>
															<div className="box-body">
																<h3 className="elementskit-info-box-title">
																	Events &amp; Decoration
																</h3>
																<div className="box-footer disable_hover_button">
																	<div className="btn-wraper">
																		<a>
																			EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																	</div>
																</div>
															</div>


														</div>
													</div>				</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-f4c3306 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="f4c3306" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-79d306f ekit-equal-height-enable elementor-widget elementor-widget-elementskit-icon-box" data-id="79d306f" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con">        {/* link opening */}
														{/* end link opening */}

														<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
															<div className="elementskit-box-header">
																<div className="elementskit-info-box-icon ">
																	<img loading="lazy" decoding="async" width="626" height="351" src="/assets/images/01/custam.jpg" className="attachment-large size-large wp-image-197" alt="" srcSet="/assets/images/01/custam.jpg 626w, /assets/images/01/custam-300x168.jpg 300w" sizes="(max-width: 626px) 100vw, 626px" />                </div>
															</div>
															<div className="box-body">
																<h3 className="elementskit-info-box-title">
																	Canteen
																</h3>
																<div className="box-footer disable_hover_button">
																	<div className="btn-wraper">
																		<Link to="/canteen">
																			EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </Link>
																	</div>
																</div>
															</div>


														</div>
													</div>				</div>
											</div>
										</div>
									</div>
									<div className="elementor-element elementor-element-72fe21e e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="72fe21e" data-element_type="container" data-e-type="container">
										<div className="e-con-inner">
											<div className="elementor-element elementor-element-f566a93 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="f566a93" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-50195ab elementor-widget elementor-widget-image" data-id="50195ab" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
													<div className="elementor-widget-container">
														<img loading="lazy" decoding="async" width="731" height="1024" src="/assets/images/03/2-731x1024.png" className="attachment-large size-large wp-image-1910" alt="" srcSet="/assets/images/03/2-731x1024.png 731w, /assets/images/03/2-214x300.png 214w, /assets/images/03/2-768x1076.png 768w, /assets/images/03/2-1097x1536.png 1097w, /assets/images/03/2.png 1428w" sizes="(max-width: 731px) 100vw, 731px" />															</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-30989b4 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="30989b4" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-a576264 elementor-widget elementor-widget-image" data-id="a576264" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
													<div className="elementor-widget-container">
														<img loading="lazy" decoding="async" width="731" height="1024" src="/assets/images/03/3-731x1024.png" className="attachment-large size-large wp-image-1911" alt="" srcSet="/assets/images/03/3-731x1024.png 731w, /assets/images/03/3-214x300.png 214w, /assets/images/03/3-768x1076.png 768w, /assets/images/03/3-1097x1536.png 1097w, /assets/images/03/3.png 1428w" sizes="(max-width: 731px) 100vw, 731px" />															</div>
												</div>
											</div>
										</div>
									</div>
									<div className="elementor-element elementor-element-a479a01 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="a479a01" data-element_type="container" data-e-type="container">
										<div className="e-con-inner">
											<div className="elementor-element elementor-element-689cc6f e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="689cc6f" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-30c869f elementor-widget elementor-widget-image" data-id="30c869f" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
													<div className="elementor-widget-container">
														<img loading="lazy" decoding="async" width="731" height="1024" src="/assets/images/03/4-731x1024.png" className="attachment-large size-large wp-image-1907" alt="" srcSet="/assets/images/03/4-731x1024.png 731w, /assets/images/03/4-214x300.png 214w, /assets/images/03/4-768x1076.png 768w, /assets/images/03/4-1097x1536.png 1097w, /assets/images/03/4.png 1428w" sizes="(max-width: 731px) 100vw, 731px" />															</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-6ed1586 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="6ed1586" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-cad7a72 elementor-widget elementor-widget-image" data-id="cad7a72" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
													<div className="elementor-widget-container">
														<img loading="lazy" decoding="async" width="731" height="1024" src="/assets/images/03/5-731x1024.png" className="attachment-large size-large wp-image-1908" alt="" srcSet="/assets/images/03/5-731x1024.png 731w, /assets/images/03/5-214x300.png 214w, /assets/images/03/5-768x1076.png 768w, /assets/images/03/5-1097x1536.png 1097w, /assets/images/03/5.png 1428w" sizes="(max-width: 731px) 100vw, 731px" />															</div>
												</div>
											</div>
										</div>
									</div>
									<div className="elementor-element elementor-element-be108df e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="be108df" data-element_type="container" data-e-type="container">
										<div className="e-con-inner">
											<div className="elementor-element elementor-element-fbce873 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="fbce873" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-531dfe2 elementor-widget elementor-widget-image" data-id="531dfe2" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
													<div className="elementor-widget-container">
														<img loading="lazy" decoding="async" width="731" height="1024" src="/assets/images/03/6-731x1024.png" className="attachment-large size-large wp-image-1909" alt="" srcSet="/assets/images/03/6-731x1024.png 731w, /assets/images/03/6-214x300.png 214w, /assets/images/03/6-768x1076.png 768w, /assets/images/03/6-1097x1536.png 1097w, /assets/images/03/6.png 1428w" sizes="(max-width: 731px) 100vw, 731px" />															</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-c6094cd e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="c6094cd" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-289fbdf elementor-widget elementor-widget-shortcode" data-id="289fbdf" data-element_type="widget" data-e-type="widget" data-widget_type="shortcode.default">
													<div className="elementor-widget-container">
														<div className="elementor-shortcode">
															<EnquiryForm widgetElementId="763" />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</article>
					</main>
				</div >
			</div >
		</div >
	)
}

export default Menu

